import { render, staticRenderFns } from "./Users1.container.vue?vue&type=template&id=af13311c&scoped=true&"
import script from "./Users1.container.vue?vue&type=script&lang=js&"
export * from "./Users1.container.vue?vue&type=script&lang=js&"
import style0 from "./Users1.container.vue?vue&type=style&index=0&id=af13311c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af13311c",
  null
  
)

export default component.exports